import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { FixtureViewType } from '@cds/betting-offer';
import { OutcomeType } from '@cds/betting-offer/add-ons';
import { EventModel, EventParticipantType } from '@frontend/sports/betting-offer/feature/model';

import { FormIndicatorComponent } from './form-indicator.component';

@Component({
    selector: 'ms-fixture-form',
    templateUrl: './fixture-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormIndicatorComponent],
})
export class FixtureFormComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() participantType?: EventParticipantType;

    americanView: boolean;
    homeTeamHomeForm?: OutcomeType[];
    awayTeamAwayForm?: OutcomeType[];
    overallHomeTeamForm?: OutcomeType[];
    overallAwayTeamForm?: OutcomeType[];

    @HostBinding('class') className = 'fixture-form';

    ngOnChanges(): void {
        const bestPerformingParticipant = this.event.getBestPerformingParticipant();

        if (this.participantType === EventParticipantType.Home) {
            this.homeTeamHomeForm = this.event.fixtureForm?.homeTeamHomeForm?.outcomes;
            this.overallHomeTeamForm =
                bestPerformingParticipant === EventParticipantType.Home ? this.event.fixtureForm?.overallHomeTeamForm?.outcomes : undefined;
        } else if (this.participantType === EventParticipantType.Away) {
            this.awayTeamAwayForm = this.event.fixtureForm?.awayTeamAwayForm?.outcomes;
            this.overallAwayTeamForm =
                bestPerformingParticipant === EventParticipantType.Away ? this.event.fixtureForm?.overallAwayTeamForm?.outcomes : undefined;
        }

        this.americanView = this.event.viewType === FixtureViewType.American;
    }
}
